var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.478061 2.65259C0.643881 1.23482 1.84512 0.165894 3.27256 0.165894H14.0153C14.1974 0.165894 14.3733 0.232154 14.51 0.352304L17.2706 2.77609C17.8912 3.321 18.234 4.11597 18.2044 4.94132L17.8604 14.5147C17.8072 15.994 16.5924 17.1659 15.1122 17.1659H3.10186C1.77224 17.1659 0.649711 16.1779 0.480861 14.8591C-0.0156294 10.9809 -0.0370193 7.05659 0.417171 3.17317L0.478061 2.65259ZM3.27256 1.66589C2.60614 1.66589 2.04532 2.16494 1.9679 2.82685L1.90702 3.34742C1.467 7.10959 1.48772 10.9114 1.96872 14.6686C2.04172 15.2388 2.52702 15.6659 3.10186 15.6659H3.73895V11.4159C3.73895 10.4494 4.52245 9.66589 5.48895 9.66589H12.489C13.4555 9.66589 14.239 10.4494 14.239 11.4159V15.6659H15.1122C15.7851 15.6659 16.3372 15.1332 16.3614 14.4608L16.7054 4.88746C16.7188 4.5123 16.563 4.15094 16.2809 3.90326L13.739 1.67139V4.01587C13.739 4.98236 12.9555 5.76587 11.989 5.76587H5.98895C5.02245 5.76587 4.23895 4.98236 4.23895 4.01587V1.66589H3.27256ZM5.73895 1.66589V4.01587C5.73895 4.15394 5.85088 4.26587 5.98895 4.26587H11.989C12.1271 4.26587 12.239 4.15394 12.239 4.01587V1.66589H5.73895ZM12.739 15.6659H5.23895V11.4159C5.23895 11.2778 5.35088 11.1659 5.48895 11.1659H12.489C12.6271 11.1659 12.739 11.2778 12.739 11.4159V15.6659Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.33f1a0225c916e5ce61a639750c23e6a.svg";
export { ForwardRef as ReactComponent };